export type PossibleKind = 'PDP' | 'CrLandingPage'; // 'ReviewList' doesn't seem to be a valid case
export type CrFilter = 'oneStar' | 'twoStar' | 'threeStar' | 'fourStar' | 'fiveStar' | 'all';

export const isCrFilter = (value: string): value is CrFilter => {
    return ['oneStar', 'twoStar', 'threeStar', 'fourStar', 'fiveStar', 'all'].includes(value);
};
